export default {
    lookup: {
        title: "查找",
        search_label: "搜索",
        search_placeholder: "搜索记录",
        column_name: "名称",
        column_createdon: "创建时间",
        button_ok: "确 定",
        button_removeValue: "移除值"
    }
}


//////////////////
// WEBPACK FOOTER
// ./packages/locale/lang/zh-CN.js
// module id = 642
// module chunks = 99